import { Component, Input } from '@angular/core';
import { UserInterface } from 'app/core/user/models';

@Component({
  selector: 'cz-user-select-item',
  templateUrl: './user-select-item.component.html',
  styleUrls: ['./user-select-item.component.scss'],
})
export class UserSelectItemComponent {
  @Input() public user: UserInterface;

  constructor() { }

}
